import { default as ArrowDown } from "assets/icons/v2/ArrowDownIcon";
import { default as Refresh } from "./RefreshIcon";
import { default as Pointer } from "./PointerIcon";
import { default as FilledTrashcan } from "./FilledTrashcanIcon";
import { default as FilledTrashcanWithBgIcon } from "./FilledTrashcanWithBgIcon";

export const DetailsIcons = {
  ArrowDown,
  Refresh,
  Pointer,
  FilledTrashcan,
  FilledTrashcanWithBgIcon,
};
